import { jsx as t } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import m from "@mui/material/Rating";
import p from "styled-components";
import n from "../../icons/favorite.js";
import { getIconSize as r, getColorPress as u, getColor as f, variants as a } from "../../theme/utils/styleUtils.js";
const I = {
  root: "ratingRoot",
  label: "ratingLabel",
  disabled: "ratingDisabled",
  focusVisible: "ratingFocusVisible",
  icon: "ratingIcon",
  iconEmpty: "ratingIconEmpty",
  iconFilled: "ratingIconFilled",
  iconActive: "ratingIconActive",
  iconFocus: "ratingIconFocus"
}, y = p(m).withConfig({
  displayName: "StyledRating"
})([
  "&&.ratingRoot{box-shadow:none;svg{height:",
  ";width:",
  ";flex-shrink:0;}}&& .ratingIcon{margin-right:8px;}&&.ratingRoot:active{color:",
  ";}&& .ratingIconEmpty{color:",
  ";}&& .ratingIconFilled{color:",
  ";}&&.ratingDisabled{opacity:0.4;}&&.ratingDisabled .ratingIconEmpty{color:",
  ";}&&.ratingRoot.ratingFocusVisible{outline:none;}&& .ratingIconFocus.ratingIconActive{outline:none;}"
], ({ $size: o }) => r(o, a.contained), ({ $size: o }) => r(o, a.contained), ({ $flavor: o, theme: i }) => u(i, void 0, o), ({ theme: o }) => o.tertiaryBackground, ({ $flavor: o, theme: i }) => f(i, void 0, o), ({ theme: o }) => o.isLightTheme ? o.colors.grey400 : o.colors.darkBlue200), b = /* @__PURE__ */ d(({ classes: o, flavor: i = "normal", emptyIcon: e = /* @__PURE__ */ t(n, {}), icon: c = /* @__PURE__ */ t(n, {}), size: l = "medium", ...g }, s) => /* @__PURE__ */ t(y, {
  ...g,
  ref: s,
  classes: {
    ...I,
    ...o
  },
  emptyIcon: e,
  icon: c,
  $flavor: i,
  $size: l
}));
b.displayName = "Rating";
export {
  b as default
};
